import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

import { RouteToLinkEvent } from '../model/event.model';

@Injectable({
  providedIn: 'root',
})
export class WkInsertWebEmailLinkService {
  _linkDetails = new BehaviorSubject<any>('');
  _closeModalDialog = new BehaviorSubject<any>('');
  _citationEditor = new BehaviorSubject<any>('');
  _miniEditor = new Subject<RouteToLinkEvent>();

  getLinkDetails() {
    return this._linkDetails.asObservable();
  }

  setLinkDetails(data: any) {
    this._linkDetails.next(data);
  }

  getCloseModalDialog() {
    return this._closeModalDialog.asObservable();
  }

  setCloseModalDialog(data: any) {
    this._closeModalDialog.next(data);
  }

  setCitationEditorInstance(data: any) {
    this._citationEditor.next(data);
  }

  getCitationEditorInstance() {
    return this._citationEditor.asObservable();
  }

  setMiniEditorDetails(data: RouteToLinkEvent) {
    this._miniEditor.next(data);
  }

  getMiniEditorDetails() {
    return this._miniEditor.asObservable();
  }
}
